import api from "@/plugins/idb";

export default {
    addItemToDb(_, item) {
        localStorage.removeItem("order_id");
        localStorage.removeItem("payment_id");
        localStorage.removeItem("payment_url");
        return api.saveOrderItem(item);
    },
    deleteItemFromDb(_, key) {
        localStorage.removeItem("order_id");
        localStorage.removeItem("payment_id");
        localStorage.removeItem("payment_url");
        return api.deleteOrderItem(key);
    },
    toggleFreshItem({ commit }) {
        commit("setCartOpenState", true);
    },
    async clearOrder({ dispatch }) {
        await api.clearOrder();
        await dispatch("setOrder");
    },
    applyPromocode({ commit, /*getters,*/ rootGetters }, data) {
        if (data.promocode) {
            data.currency = rootGetters["globalvars/getCurrencyCode"];
            this.$axios
                .get("/api/promocodes/check?" + this.$grom.objToParams(data))
                .then((res) => {
                    if (res.data.total - res.data.total_with_discount > 0) {
                        // let total = this.getters["order/getCartTotal"];
                        commit("setPromoTotal", res.data.total);
                        commit("setPromoTotalWithDiscount", res.data.total_with_discount);
                        commit("setPromoValue", data.promocode);
                        commit("setPromoData", res.data);
                        commit(
                            "setPromoMessage",
                            `${this.$i18n.t("promo_used")} ${
                                res.data.discount_value.toLocaleString("ru-RU") +
                                (res.data.discount_mode == "percent"
                                    ? "%"
                                    : '<span class="money">' + rootGetters["globalvars/getCurrency"] + "</span>")
                            }`
                        );
                        commit("setDiscountInfo", "promo-code");
                    } else {
                        commit("setPromoTotalWithDiscount", 0);
                        commit("setPromoValue", "");
                        commit("setPromoData", null);
                        commit("setPromoMessage", this.$i18n.t("promocode_zero_value"));
                        commit("resetDiscountInfo");
                    }
                })
                .catch((error) => {
                    console.log(`err =>`, [error]);
                    commit("setPromoTotalWithDiscount", 0);
                    commit("setPromoValue", "");
                    commit("setPromoData", null);
                    commit("setPromoMessage", error.response?.data?.error || error.response.error);
                    commit("resetDiscountInfo");
                });
        } else {
            commit("setPromoTotalWithDiscount", 0);
            commit("setPromoTotal", 0);
            commit("setPromoValue", "");
            commit("setPromoMessage", "");
            commit("setPromoData", null);
            commit("resetDiscountInfo");
        }
    },
    applyDiscountBonuses({ commit }, data) {
        try {
            this.$axios.post("/api/bonuses/calculate", data).then((res) => {
                let response = res.data.data;

                commit("setPromoTotal", response.total);
                commit("setPromoTotalWithDiscount", response.total_with_discount);
                commit("setPromoValue", response.discount_value);
                commit("setPromoData", response);
                commit("setAppliedBonuses", response.discount_value);
                commit("setDiscountInfo", "bonuses");
            });
        } catch (e) {
            console.log(e);
        }
    },
    resetDiscountBonuses({ commit }) {
        commit("setPromoTotalWithDiscount", 0);
        commit("setPromoTotal", 0);
        commit("setPromoValue", "");
        commit("setPromoMessage", "");
        commit("setPromoData", null);
        commit("setAppliedBonuses", 0);
        commit("resetDiscountInfo");
    },
    async setOrder({ commit }) {
        let items = await api.getOrder();

        commit("setOrder", items);
        let list = Object.keys(items);

        localStorage.setItem("orderItemsCount", list.length);
        if (list.length > 0) {
            const res = await this.$axios.get("/api/skus", {
                params: {
                    id: list,
                },
            });

            commit("setLiveItems", res.data);

            let liveItems = Array();

            res.data.map(function (itemLive) {
                liveItems.push(parseInt(itemLive.id));
            });

            list.map(function (value) {
                let intValue = parseInt(value);
                if (!liveItems.includes(intValue)) {
                    api.deleteOrderItem(intValue);
                }
            });
            console.log("order-setted");
        }
    },
};
